export const authenticated = state => {
    return state.authenticated;
}